import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/img/logo-128.png';
import { useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { hideLoading, logIn, showLoading } from '../features/general/generalSlice';
import { API_URL } from '../config/constants';
import axios from 'axios';

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRefEmail = useRef(null)
  const inputRefName = useRef(null)
  const inputRefPassword = useRef(null)
  const inputRefRetypePassword = useRef(null)
  const [registerFields, setRegisterFields] = useState({
    email: '',
    name: '',
    password: '',
    retypePassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = value.trim() || '';
    setRegisterFields((prevFields) => ({
      ...prevFields,
      [name]: newValue,
    }));
  };

  const handleSignup = async (e)=> {
    e.preventDefault();
    toast.dismiss();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!registerFields.email){
      inputRefEmail.current.focus();
      toast.error('Please enter your Email ID');
      return;
    }else if(!emailPattern.test(registerFields.email)){
      inputRefEmail.current.focus();
      toast.error('Please enter valid Email ID');
      return;
    }else if(!registerFields.name){
      inputRefName.current.focus();
      toast.error('Please enter your Full Name');
      return;
    }else if(!registerFields.password){
      inputRefPassword.current.focus();
      toast.error('Please enter your Password');
      return;
    }else if(!registerFields.retypePassword){
      inputRefRetypePassword.current.focus();
      toast.error('Please retype your Password');
      return;
    }else if(registerFields.password !== registerFields.retypePassword){
      inputRefRetypePassword.current.focus();
      toast.error('Both passwords must match');
      return;
    }

    try {
      setTimeout(() => {
        dispatch(showLoading());
      }, 100);
      const response = await axios.post(`${API_URL}/auth`, {
        callback: 'register',
        email: registerFields.email,
        name: registerFields.name,
        password: registerFields.password
      }, {
        withCredentials: true  // Allows cross-origin cookies if server allows
      });
      if(response?.status === 200){
        //toast.success(`${response.data.message}`);
        setTimeout(() => {
          dispatch(logIn(response.data.user));
          navigate('/');
        }, 1000);
      }else{
        toast.error(`${response?.status}: ${response?.statusText}`);
      }
    } catch (error) {
      toast.error(`Error : ${error.response.data.message}`);
    } finally{
      setTimeout(() => {
        dispatch(hideLoading());
      }, 1000);
    }
  }

  return (
    <div className='Welcome'>
      <ToastContainer
        toastId={'signup-message'}
        position='top-center'
        autoClose={5000}
      />
      <img src={Logo} alt="" />
      <h4>Signup</h4>

      <form action="">
        <div className="form-group">
          <input type="text" id="email" name="email" className='form-control' placeholder="Your Email ID*" onChange={handleChange} ref={inputRefEmail} />
          <div className="text-danger"></div>
        </div>
        <div className="form-group">
          <input type="text" id="name" name="name" className='form-control' placeholder="Your Full Name*" onChange={handleChange} ref={inputRefName} />
        </div>
        <div className="form-group">
          <input type="password" id="password" name="password" className='form-control' placeholder="Your Password*" onChange={handleChange} ref={inputRefPassword} />
        </div>
        <div className="form-group">
          <input type="password" id="retype-password" name="retypePassword" className='form-control' placeholder="Retype Password*" onChange={handleChange} ref={inputRefRetypePassword} />
        </div>
        <button 
          type='submit' 
          className="btn btn-site bg-site text-site-light btn-animation fw-medium mt-2"
          onClick={handleSignup}
        >Sign up</button>
        <div className="mt-2">
          <Link to={"/login"} className="fw-medium text-muted">Log in</Link>
        </div>
      </form>

    </div>
  )
}

export default Signup